import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IRightColumnData, IRightColumnSection } from '@shared/common/interfaces/right-column-data.interface';

@Component({
    selector: 'app-right-side-info-column',
    templateUrl: './right-side-info-column.component.html',
    styleUrls: ['./right-side-info-column.component.scss'],
    standalone: false
})
export class RightSideInfoColumnComponent implements OnInit {
  @Input() data!: IRightColumnData[];
  @Input() isHelp: boolean = false;
  @Input() isInterest: boolean = false;
  @Input() isReforma: boolean = false;
  @Input() interestOneText: string = 'Sugerencia de fondos';
  @Input() interestTwoText: string = 'Perfil de riesgo';
  @Output() idRightColumnEmit = new EventEmitter<string>();
  componentData!: any;
  activeSection: any = null;

  constructor(private readonly router: Router) { }

 

  ngOnInit() {
    this.componentData = this.data;
   
    //setea seccion activa por defecto
    for (let element of this.componentData) {
      const activeSubSection = element.sections.find((subSection: any) => subSection.active);
      if (activeSubSection) {
        this.activeSection = activeSubSection;
        break;
      }
    }
  }

  setActiveAndExecuteAction(subSection: IRightColumnSection){
    this.activeSection = subSection;
    this.idRightColumnEmit.emit(subSection.element);
  }

  getSubCardClass(subSection: any) {
    return this.activeSection === subSection ? 'sub-card-base sub-card-active' : 'sub-card-base sub-card-inactive';
  }

  getSubCardButtonClass(subSection: any) {
    return this.activeSection === subSection ? 'sub-card-btn sub-card-btn-active' : 'sub-card-btn sub-card-btn-inactive';
  }

  goToVideoAtencion(){
    this.router.navigate(['/video-atencion']);
  }

  goToOneText(){

    if(this.isReforma) {
      window.open('https://www.afpcapital.cl/reforma-de-pensiones', '_blank');
    } else {
      this.router.navigate(['/tools/advisory/funds-advisory']);
    }
  }

  goToTwoText(){

    if(this.isReforma) {
      window.open('https://capitalplay.afpcapital.cl/reforma', '_blank');
    } else {
      this.router.navigate(['/tools/advisory/investor-profile']);
    }
  }
}
